import { Component, OnInit, Input } from '@angular/core';

import {
  _testNotesGlobals,
} from '../models/Notes.models';

import { NotesService } from '../../../services/notes.service';
import { MessagingService } from '../../../services/messaging.service';
import {NoteGroupDataModel} from '../../../models/notes/note-group-data.model';

@Component({
  selector: 'app-note-compact-v2',
  templateUrl: './note-compact-v2.component.html',
  styleUrls: ['./note-compact-v2.component.css']
})
export class NoteCompactV2Component implements OnInit {

  @Input() height: string = '500px';
  @Input() width: string = '350px';

  @Input() PatientID: string;
  @Input() CaseID: string;
  @Input() PatientName: string;
  @Input() NoteGroupId: string;
  @Input() ParentObjectName: string;
  @Input() ObjectId: string;

  isLoading: boolean = false;
  messagingSubscription: any;
  chooseMode: boolean = false;
  dataNoteGroups: NoteGroupDataModel[] = [];
  backupDataNoteGroups: NoteGroupDataModel[] = [];

  constructor(
    private notesGlobals: _testNotesGlobals,
    private messagingService: MessagingService,
    private notesService: NotesService,
  ) { }

  ngOnInit() {

    this.setupTest();
    this.initWithQueryObj();

    this.messagingSubscription = this.messagingService.componentMessageCall
      .subscribe(response => {

        if (response.event == 'Notes-Startup') {
          this.clearCurrentQuery();
          this.PatientID = response.data.PatientID;
          this.CaseID = response.data.CaseID;
          this.PatientName = response.data.PatientName;
          this.NoteGroupId = response.data.NoteGroupId;
          this.ParentObjectName = response.data.ParentObjectName;
          this.ObjectId = response.data.ObjectID;
          this.initWithQueryObj();
        }

        if (response.event == "MessagingConstants.PATIENT_CHANGED") {
          if (response.data.clearCurrentQuery) { this.clearCurrentQuery(); }
          this.PatientID = response.data.PatientID;
          this.PatientName = response.data.PatientName;
          this.initWithQueryObj();
        }

        if (response.event == "NoteGroup-Changed-Event") {
          if (response.data.clearCurrentQuery) { this.clearCurrentQuery(); }
          this.NoteGroupId = response.data.NoteGroupId;
          this.initWithQueryObj();
        }

        if (response.event == "NoteParentObject-Changed-Event") {
          if (response.data.clearCurrentQuery) { this.clearCurrentQuery(); }
          this.ObjectId = response.data.ObjectID;
          this.ParentObjectName = response.data.ParentObjectName;
          this.initWithQueryObj();
        }

        if (response.event == "Notes-Query") {
          this.clearCurrentQuery();
          this.PatientID = response.data.PatientID;
          this.NoteGroupId = response.data.NoteGroupId;
          this.PatientName = response.data.PatientName;
          this.ParentObjectName = response.data.ParentObjectName;
          this.ObjectId = response.data.ObjectID;
          this.initWithQueryObj();
        }

      });
  }

  setupTest() {
    this.PatientID = this.notesGlobals.NOTE_GROUP_PATIENTID;
    this.ParentObjectName = this.notesGlobals.NOTE_GROUP_OBJECTYPE;
    this.ObjectId = this.notesGlobals.NOTE_GROUP_OBJECTID;
    this.PatientName = 'Jack';
  }

  initWithQueryObj() {
    this.isLoading = true;
    this.fetchNoteGroupsByQueryObj(this.buildQuery())
      .then((results: NoteGroupDataModel[]) => {
        if (!results) {
          this.isLoading = false;
          return;
        }
        this.dataNoteGroups = results;
        this.filterDeletedNotes();
        this.orderNotes();
        this.backupNoteGroups();
        this.isLoading = false;
      }, err => {
        console.log('Note-Compact Error', err);
        this.isLoading = false;
      });
  }

  clearCurrentQuery() {
    this.PatientID = null;
    this.NoteGroupId = null;
    this.ObjectId = null;
    this.ParentObjectName = null;
  }

  fetchNoteGroupsByQueryObj(queryObj: any) {
    let promise = new Promise((resolve, reject) => {
      this.notesService.getNoteByQuery(queryObj)
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  buildQuery() {
    let query = {
      PatientID: this.PatientID,
      NoteGroupId: this.NoteGroupId,
      ObjectID: this.ObjectId,
    };
    return query;
  }

  filterDeletedNotes() {
    this.dataNoteGroups = this.dataNoteGroups.filter(ng => { return ng.xauditDeleted == false; });
  }

  orderNotes() {
    this.dataNoteGroups = this.dataNoteGroups.sort((a, b) => {
      let d1 = new Date(a.dataNote.xauditModifiedOn).getTime();
      let d2 = new Date(b.dataNote.xauditModifiedOn).getTime();
      return d2 - d1;
    });
  }

  backupNoteGroups() {
    this.backupDataNoteGroups = JSON.parse(JSON.stringify(this.dataNoteGroups));
  }

}
